<div class="dialog__wrapper">
  <form (ngSubmit)="handleConfirm()" [formGroup]="statusForm">
    <div class="dialog__header"  mat-dialog-title>
      <h4 class="dialog__title">Change status - {{ data.title ?? data.accountId }}</h4>
      <button mat-icon-button type="button" (click)="handleClose()">
        <mat-icon fontIcon="close"></mat-icon>
      </button>
    </div>
    <mat-dialog-content class="dialog__content">
      <section class="dialog__content__cols">
        <div class="dialog__content__col">
          <span>From:</span>
          <span>To:</span>
          @if (data.showReason) {
            <span>Reason:</span>
          }
        </div>
        <div class="dialog__content__col">
          <span class="bold">{{ data.currentRegistrationStatus | toStatusDesc }}</span>
          <span class="bold">{{ data.newRegistrationStatus | toStatusDesc }}</span>
          <mat-form-field class="form-field-double" *ngIf="data.showReason">
            <textarea [formControl]="statusForm.controls.reason" matInput cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="5"></textarea>
            <mat-error>Reason is required</mat-error>
          </mat-form-field>
        </div>
      </section>
      <div *ngIf="roleService.isAdmin">
        <p>
          @if (showInfoMessage) {
            Note that: An email will be sent to all organisation contacts.
          }
        </p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button type="button" class="button--secondary button--pad-right" (click)="handleClose()">Cancel</button>
      <button mat-raised-button type="submit">Confirm</button>
    </mat-dialog-actions>
  </form>
</div>
